import { Injectable } from '@angular/core';

import { of, from, switchMap, catchError, Observable } from 'rxjs';
import { GoogleAuthProvider, signInWithPopup, UserCredential } from 'firebase/auth';

import { AlertsService } from '@tablesready/frontend-alerts-bar';
import { FirebaseService } from '../../services';
import { FirebaseGoogleAuthResponse } from '../models';

interface UserCredentialWithToken extends UserCredential{
  token: string;
}

@Injectable()
export class FirebaseAuthService {
  private userCredentials: UserCredentialWithToken = null;

  constructor(
    private readonly alertsService: AlertsService,
    private readonly firebaseService: FirebaseService,
  ) {}

  get userCredential(): UserCredentialWithToken {
    return this.userCredentials;
  }

  authenticateByGoogle(): Observable<FirebaseGoogleAuthResponse> {
    const provider = new GoogleAuthProvider();

    return from(signInWithPopup(this.firebaseService.firebaseAuth, provider).then(data => data))
      .pipe(
        switchMap(data => from(data.user.getIdToken().then(token => {
          return {
            data,
            token,
          };
        }))),
        catchError(err => {
          if (!err.message.includes('auth/popup-closed-by-user')) {
            this.alertsService.addError(err.message, 'Error: ');
          }

          return of(null);
        }),
      );
  }

  setUserCredential(data: UserCredentialWithToken): void {
    this.userCredentials = data;
  }
}
